import { criteriaFieldsGQLQueryFragment, criteriaAllowedTiersGQLQueryFragment, criteriaRequiredSkusGQLQueryFragment } from '~internal/utils/OfferNotificationContext';

const skuQueryFragment = `
    inCart
    formattedPrice
    skuID
    inventoryStatus
    largeImage
    shadeName
    skuBaseID
    productName
    productCode
    altProductImages
    productWhoItIsFor
    productConcern
    shortDescription
    path
    PRODUCT_SIZE
`;

export const LoyaltyRewards = (rewardOfferType: string) => {
    const viewArr  = rewardOfferType.split(',');
    const loyaltyRewardsQuery = `{
        user {
            benefits (views:[${viewArr}]) {
                id
                inCart
                points
                offerCode
                image
                meetsCriteria
                used
                skuBased
                criteria
                pointsNeeded
                benefits
                criteriaViewValidations {
                    class
                    met
                }
                promo {
                    text {
                        title
                        subHeading
                        description
                        action
                        quickshop
                        redeemed
                        howToUse
                    }
                    URL {
                        action
                        learnMore
                        terms
                    }
                }
                sku {
                    ${skuQueryFragment}
                }
                ${criteriaFieldsGQLQueryFragment}
                ${criteriaAllowedTiersGQLQueryFragment}
                ${criteriaRequiredSkusGQLQueryFragment}
                skus {
                    choices
                    choicesPcatData {
                        skuData {
                            ${skuQueryFragment}
                        }
                    }
                }
            }
        }
    }
  `;

    return loyaltyRewardsQuery;
};
